import React from 'react';
import {
  ripleyBank,
  ripleyGoPoints,
  ripleyBankPayAccount,
} from '../config/paths';

export const alertMessagePicker = (motiveId) => {
  switch (motiveId) {
    case '22':
      return (
        <React.Fragment>
          Para consultar el saldo de una Gift Card, ingresa a bancoripley.com e
          inicia sesión para ser atendido directamente por EVA o un ejecutivo;
          también puedes llamar al <strong>800 20 32 20</strong> o desde celular
          al <strong>227689200</strong>.
        </React.Fragment>
      );
    case '23':
      return (
        <React.Fragment>
          Para información de un Seguro Ripley, ingresa a{' '}
          <a
            style={{ textDecoration: 'none' }}
            href={ripleyBank}
            target="blank"
          >
            bancoripley.com
          </a>{' '}
          e inicia sesión para ser atendido directamente por EVA o un ejecutivo;
          también puedes llamar al <strong>800 20 32 20</strong> o desde celular
          al <strong>227689200</strong>.
        </React.Fragment>
      );
    case '32':
      return 'Se extenderá la vigencia de tu Gift Card Empresa. Cualquier inconveniente debes revisarlo con la plataforma donde adquiriste la Gift Card.';
    case '25':
      return (
        <React.Fragment>
          Para bloquear tu Tarjeta Ripley, ingresa{' '}
          <a
            style={{ textDecoration: 'none' }}
            href={ripleyBank}
            target="blank"
          >
            aquí
          </a>{' '}
          e inicia sesión para ser atendido directamente por EVA o un ejecutivo;
          también puedes llamar al <strong>800 20 32 20</strong> o desde celular
          al <strong>227689200</strong>.
        </React.Fragment>
      );
    case '24':
      return (
        <React.Fragment>
          Puedes pagar tu Estado de Cuenta{' '}
          <a
            style={{ textDecoration: 'none' }}
            href={ripleyBankPayAccount}
            target="blank"
          >
            aquí
          </a>
          ; también puedes llamar al <strong>800 20 32 20</strong> o desde
          celular al <strong>227689200</strong>.
        </React.Fragment>
      );
    case '20':
      return (
        <React.Fragment>
          Para información sobre tus RipleyPuntos Go, ingresa{' '}
          <a
            style={{ textDecoration: 'none' }}
            href={ripleyGoPoints}
            target="blank"
          >
            aquí
          </a>{' '}
          e inicia sesión para ser atendido directamente por EVA o un ejecutivo;
          también puedes llamar al <strong>800 20 32 20</strong> o desde celular
          al <strong>227689200</strong>.
        </React.Fragment>
      );
    case '12':
      return (
        <React.Fragment>
          Para realizar el cambio de tu Tarjeta Ripley, ingresa{' '}
          <a
            style={{ textDecoration: 'none' }}
            href={ripleyBank}
            target="blank"
          >
            aquí
          </a>{' '}
          e inicia sesión para ser atendido directamente por EVA o un ejecutivo;
          también puedes llamar al <strong>800 20 32 20</strong> o desde celular
          al <strong>227689200</strong>.
        </React.Fragment>
      );
    default:
      return '';
  }
};
